package top.wcpe.allincore.ui.runtime.element

import kotlin.jvm.JvmStatic

/**
 * 分隔线。
 */
class Divider private constructor() : UIElement<Divider>() {

    private var colorArgb: Int = DEFAULT_COLOR
    private var thicknessPx: Float = DEFAULT_THICKNESS

    protected override fun self(): Divider = this

    /** 设置颜色（ARGB），返回自身以便链式调用。 */
    fun color(argb: Int): Divider {
        colorArgb = argb
        return this
    }

    /** 设置线宽（像素），返回自身以便链式调用。 */
    fun thickness(thickness: Float): Divider {
        thicknessPx = thickness
        return this
    }

    fun color(): Int = colorArgb

    fun thickness(): Float = thicknessPx

    companion object {
        /** 默认分隔线颜色：浅灰（ARGB，0xFFAAAAAA 超出 Int 正区间，按位转 Int）。 */
        private val DEFAULT_COLOR = 0xFFAAAAAA.toInt()

        /** 默认线宽（像素）。 */
        private const val DEFAULT_THICKNESS = 1f

        /** 创建一个分隔线。 */
        @JvmStatic
        fun create(): Divider = Divider()
    }
}
